// Padding
export const ENABLED_PADDING_KEYS = ['0_5', '1', '1_5', '2', '2_5', '3', '4', '5', '6', '7', '8', '9', '10', '12', '15', '16', '17_5', '20'];
// Radius
export const ENABLED_RADIUS_KEYS = ['rounded-sm', 'rounded', 'rounded-md', 'rounded-lg', 'rounded-xl', 'rounded-2xl'];